import { Tooltip } from '@material-ui/core';
import React from 'react';

import CountryFlag from '@components/CountryFlag';
import ImportedTag from '@components/ImportedTag';
import { toastSuccess } from '@components/Toast';

import AddedColors from '@features/materials/components/AddedColors';

import {
	FAVOURITES,
	getConsumptionUnit,
	getConsumptionUnitForTrimsAccessories,
	setCardNameInfo,
	whichUserInventoryCheck,
	whichUserMaterialEditAndDuplicateAndDeleteCheck
} from '@utils/MaterialsUtil';
import { changeDateFormat, replaceUnderLine } from '@utils/Util';

import { MATERIALS_TYPE } from '@/constants/constant';

import CommonImage from '@/components/CommonImage';
import AlertQuantityPopup from '@/features/materials/components/AlertQuantityPopup';

const MaterialCardItemView = ({
	cardOrigin,
	materialsData,
	selectedMaterialIdList,
	isAllCheckedButtonClicked,
	handleMaterialSelection,
	setSelectedItem,
	onMaterialClick,
	activeStep,
	inventoryModalOpen,
	onEdit,
	onExpired,
	setRemove,
	onLikeMaterial,
	onUnlikeMaterial,
	cardModelName,
	showHistory,
	setShowHistory,
	isImportedFabric,
	markMaterialForAlert,
	openAlertQuantityPopup,
	setOpenAlertQuantityPopup,
	alertQuantity,
	setAlertQuantity,
	setOpenUnmarkAlertConfirmationModal
}) => {
	const renderCardItemBody = (item) => {
		const consumptionUnit =
			item?.materialType !== 'Trims' && item?.materialType !== 'Branding'
				? getConsumptionUnit(item)
				: getConsumptionUnitForTrimsAccessories(item);

		return (
			<div
				className={
					'single-design-card with-editable ' +
					(selectedMaterialIdList?.includes(item.materialId) || isAllCheckedButtonClicked
						? 'hovered'
						: item?.liked
							? 'favorited'
							: '')
				}
				key={'material_' + item.materialId}
			>
				<div className="card-top">
					<div className="edit-items">
						<div className="select-and-edit d-flex justify-content-between">
							<div className="custom-chekbox">
								{activeStep === MATERIALS_TYPE.FABRIC && (
									<div className="form-group d-flex">
										{cardOrigin !== 'SIMILAR' && (
											<>
												<input
													type="checkbox"
													id={`select_${item.materialId}`}
													name={`select_${item.materialId}`}
													checked={
														selectedMaterialIdList?.includes(item.materialId) ||
														isAllCheckedButtonClicked
													}
													onChange={(e) =>
														handleMaterialSelection(e, item.materialId)
													}
												/>
												<label htmlFor={`select_${item.materialId}`} />{' '}
											</>
										)}
										{item?.liked ? (
											<img
												src={`${process.env.PUBLIC_URL}/icons/favorite.svg`}
												alt="favourite"
												className="add-to-favorite"
												onClick={(e) => {
													onUnlikeMaterial(item.materialId);
													e.stopPropagation();
												}}
											/>
										) : (
											<img
												src={`${process.env.PUBLIC_URL}/icons/not-favorite.svg`}
												alt="not-favourite"
												className="add-to-favorite"
												onClick={(e) => {
													onLikeMaterial(item.materialId);
													e.stopPropagation();
												}}
											/>
										)}
									</div>
								)}
							</div>
							<div className="d-flex justify-content-between">
								<div className="option create-option-dropdown">
									{cardOrigin !== 'PAIR_MATERIAL' && (
										<div className="dropdown">
											<button
												className="btn btn-default dropdown-toggle"
												type="button"
												id="menu1"
												data-toggle="dropdown"
												aria-expanded="false"
											>
												<img
													src={`${process.env.PUBLIC_URL}/icons/more_icon.svg`}
													alt="more"
												/>
											</button>
											<ul
												className="dropdown-menu dropdown-menu-right shadow-lg"
												role="menu"
												aria-labelledby="downloadType"
												x-placement="bottom-end"
											>
												<li>
													<span
														onClick={(e) => {
															e.stopPropagation();
															navigator.clipboard.writeText(
																`${
																	item.referenceNumber
																		? item.referenceNumber + ' : '
																		: ''
																} ${item.name}`
															);
															toastSuccess('Copied');
														}}
													>
														Copy {activeStep?.toLowerCase()} &amp; Ref
													</span>
												</li>
												<li>
													<span
														onClick={(e) => {
															e.stopPropagation();
															navigator.clipboard.writeText(
																`${
																	item.supplierRefNumber
																		? item.supplierRefNumber + ' : '
																		: ''
																} ${item.supplierName}`
															);
															toastSuccess('Copied');
														}}
													>
														Copy supplier &amp; Ref{' '}
													</span>
												</li>
												{cardModelName !== FAVOURITES &&
													whichUserMaterialEditAndDuplicateAndDeleteCheck() && (
														<li className="border-top-solid">
															<span
																onClick={(e) => onEdit(e, item, 'Duplicate')}
															>
																Duplicate {activeStep?.toLowerCase()}
															</span>
														</li>
													)}
												{!item?.isExpired && whichUserInventoryCheck() && (
													<li className="border-top-solid">
														<span
															className="semibold-12 gray_dark_02"
															onClick={(e) => inventoryModalOpen(e, item)}
														>
															Update inventory
														</span>
													</li>
												)}
												{whichUserInventoryCheck() && (
													<li>
														<span onClick={(e) => onExpired(e, item)}>
															Marked as{' '}
															{item.isExpired ? 'unexpired' : 'expired'}{' '}
														</span>
													</li>
												)}
												{(activeStep === MATERIALS_TYPE.FABRIC ||
													activeStep === MATERIALS_TYPE.TRIMS) &&
													!item?.needBalanceAlert && (
														<li className="alert-dropdown">
															<span
																onClick={(e) => {
																	e.stopPropagation();
																	setOpenAlertQuantityPopup(
																		(prev) => !prev
																	);
																	setSelectedItem(item);
																}}
															>
																Mark for Alert
															</span>
															{openAlertQuantityPopup && (
																<AlertQuantityPopup
																	markMaterialForAlert={
																		markMaterialForAlert
																	}
																	alertQuantity={alertQuantity}
																	setAlertQuantity={setAlertQuantity}
																/>
															)}
														</li>
													)}
												{(activeStep === MATERIALS_TYPE.FABRIC ||
													activeStep === MATERIALS_TYPE.TRIMS) &&
													item?.needBalanceAlert && (
														<li className="alert-dropdown">
															<span
																onClick={(e) => {
																	e.stopPropagation();
																	setOpenUnmarkAlertConfirmationModal(true);
																	setSelectedItem(item);
																}}
																className="white-space-nowrap"
															>
																Unmark for Alert ({item?.balanceAlertLimit}{' '}
																{consumptionUnit})
															</span>
														</li>
													)}

												{whichUserMaterialEditAndDuplicateAndDeleteCheck() && (
													<li>
														<span onClick={(e) => onEdit(e, item, 'Edit')}>
															Edit
														</span>
													</li>
												)}
												{whichUserMaterialEditAndDuplicateAndDeleteCheck() && (
													<li>
														<span
															className="red"
															onClick={(e) => {
																e.stopPropagation();
																setRemove(true);
																setSelectedItem(item);
															}}
														>
															Delete
														</span>
													</li>
												)}
												<li onClick={() => setShowHistory(item?.materialId)}>
													<span id={item?.materialId}>View History</span>
												</li>
											</ul>

											{/* View history popup */}
											{showHistory === item?.materialId && (
												<div className="view-history-popup shadow">
													<div className="title d-flex justify-content-between px-3 my-12 ">
														<p className="semibold-16 ml-1">View History</p>
														<img
															src={`${process.env.PUBLIC_URL}/icons/close.svg`}
															alt="close"
															className="cursor-pointer"
															onClick={() => setShowHistory(null)}
														/>
													</div>
													<div className="body p-3 border-top-solid text-left">
														<div className="mb-4 mx-1">
															<p className="regular-14 gray_dark_02 weight-500">
																Fabric added by:
															</p>
															<p className="regular-14 gray_dark_02">
																{item?.createdBy &&
																	item?.createdBy.split(' ')[1]}
																,
																<span className="ml-1">
																	{changeDateFormat(
																		item?.createdAt,
																		'',
																		'DD MMM, YYYY [at] hh:mm A'
																	)}
																</span>
															</p>
														</div>
														<div className="mx-1">
															<p className="regular-14 gray_dark_02 weight-500">
																Last edit by:
															</p>
															<p className="regular-14 gray_dark_02">
																{item?.modifiedBy &&
																	item?.modifiedBy.split(' ')[1]}
																,
																<span className="ml-1">
																	{changeDateFormat(
																		item?.modifiedAt,
																		'',
																		'DD MMM, YYYY [at] hh:mm A'
																	)}
																</span>
															</p>
														</div>
													</div>
												</div>
											)}
										</div>
									)}
									{cardOrigin === 'PAIR_MATERIAL' && (
										<CommonImage
											src={`/icons/delete_gray.svg`}
											alt="close"
											className="cursor-pointer mt-6"
											onClick={(e) => {
												e.stopPropagation();
												setRemove(true);
												setSelectedItem(item);
											}}
										/>
									)}
								</div>
							</div>
						</div>
					</div>
					<span
						data-toggle="modal"
						data-target="#designViewModal"
						onClick={() => onMaterialClick(item, activeStep)}
					>
						{item?.docUrl && <img src={item.docUrl} className="card-image" alt="product-image" />}
						{!item?.docUrl && (
							<img
								src={`${process.env.PUBLIC_URL}/images/fabric-default.png`}
								className="card-image"
								alt="product-image"
							/>
						)}
						{isImportedFabric ? isImportedFabric(item) && <ImportedTag /> : null}
						{item?.pairType && (
							<span className="status teal-3 pair-type position-absolute right-3 bottom-3">
								{replaceUnderLine(item?.pairType)}
							</span>
						)}
						{cardOrigin === 'MATERIAL_LIST' && item?.pairCount && (
							<span className="status teal-3 pair-type position-absolute right-3 bottom-3">
								Matching ({item?.pairCount})
							</span>
						)}
					</span>
				</div>
				<div className="card-content" data-toggle="modal" data-target="#designViewModal">
					<div className="card-info">
						<p className="status d-flex justify-content-between align-items-start pr-0 mb-2">
							<span className="pt-0">
								<span className="title-number semibold-12">{item?.referenceNumber}</span>
								<span className="ml-2">
									<CountryFlag countryId={item?.inventoryCountryResponse?.id} />
								</span>
							</span>
							{!item?.isExpired && !item?.isLowQuantity && (
								<span
									className={
										item?.stockQuantity > 0 ? 'inventory-value' : 'inventory-value empty'
									}
								>
									{item?.stockQuantity
										? parseFloat(item?.stockQuantity).toFixed(2).replace('.00', '') +
											' ' +
											consumptionUnit
										: ''}
								</span>
							)}
							{item?.isExpired && (
								<span className="expired red">
									Expired: {item?.expiredStockQuantity}&nbsp;
									{consumptionUnit}
								</span>
							)}
							{item?.isLowQuantity && (
								<span className="expired red">
									Low Qty: {item?.expiredStockQuantity}&nbsp;
									{consumptionUnit}
								</span>
							)}
						</p>
						{cardOrigin === 'PAIR_MATERIAL' && (
							<p className="gray_dark_01 regular-12 pt-0">
								{setCardNameInfo(item, item.materialType === 'Trims' ? 'TRIMS' : 'FABRIC')}
							</p>
						)}
						<ul
							className="common-list-component"
							onClick={() => onMaterialClick(item, activeStep)}
						>
							{/*className="text-uppercase"*/}
							<li>
								<Tooltip title={setCardNameInfo(item, activeStep)} placement={'top'} arrow>
									<span className="regular-12 gray_dark_02 ">
										{setCardNameInfo(item, activeStep)}
									</span>
								</Tooltip>
							</li>
						</ul>

						<div
							className="color d-flex align-items-center mt-2"
							onClick={() => onMaterialClick(item, activeStep)}
						>
							<AddedColors
								colorGroupResponseList={item?.materialColorResponse?.colorGroupResponseList}
								colorResponse={
									Object.keys(item.materialColorResponse.colorResponse).length > 0
										? item?.materialColorResponse?.colorResponse
										: undefined
								}
								colorType={item?.materialColorResponse?.colorType?.name}
								viewType="cardView"
							/>
						</div>
					</div>
				</div>
			</div>
		);
	};

	return (
		<>
			{materialsData?.data
				?.filter(
					(item, index, self) => index === self.findIndex((t) => t.materialId === item.materialId)
				)
				.map((item) => {
					return renderCardItemBody(item);
				})}
		</>
	);
};
export default MaterialCardItemView;
